import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import TextField from "material-ui/TextField";
import Slider from "material-ui/Slider";
import RemoveCircle from "material-ui/svg-icons/content/remove-circle";

import Chip from "material-ui/Chip";
import DateField from "components/Form/DateField";

import {
  mediagroups,
  segments,
  categories,
  filters,
  menus
} from "data/actions";
import { TOGGLE_RIGHT } from "data/menus/types";
import {
  UPDATE_FILTER_MEDIAGROUPS,
  UPDATE_FILTER_SEGMENTS,
  UPDATE_FILTER_CATEGORIES,
  UPDATE_FILTER_TARGETS,
  UPDATE_FILTER_SEARCH,
  UPDATE_FILTER_AGE,
  UPDATE_FILTER_GENDER,
  UPDATE_FILTER_REACH,
  UPDATE_FILTER_BUDGET
} from "data/filters/types";
import ChipField from "components/Form/ChipField";
import Label from "components/Form/Label";
import * as os from "osutil";

class BrandsFilter extends Component {
  static contextTypes = {
    router: PropTypes.object
  };

  componentWillMount() {
    this.props.actions.fetchMediagroups();
    this.props.actions.fetchSegments();
    this.props.actions.fetchCategories();
  }

  onSearchChange = (event, value) => {
    this.props.actions.updateFilterSearch(event.target.value);
  };
  onSegmentChange = selected => {
    this.props.actions.updateFilterSegments(selected);
  };

  onTargetChange = selected => {
    this.props.actions.updateFilterTarget(selected);
  };

  onCategoriesChange = selected => {
    this.props.actions.updateFilterCategories(selected);
  };

  onMediagroupsChange = selected => {
    this.props.actions.updateFilterMediagroups(selected);
  };

  onReachChange = (event, value) => {
    this.props.actions.updateFilterReach(value);
  };

  onClearReach = () => {
    this.props.actions.updateFilterReach();
  };

  onBudgetChange = (event, value) => {
    this.props.actions.updateFilterBudget(value);
  };

  onClearBudget = () => {
    this.props.actions.updateFilterBudget();
  };

  onGenderChange = (event, value) => {
    this.props.actions.updateFilterGender(value);
  };

  onClearGender = () => {
    this.props.actions.updateFilterGender();
  };

  onAgeChange = (event, value) => {
    this.props.actions.updateFilterAge(value);
  };

  onClearAge = () => {
    this.props.actions.updateFilterAge();
  };

  onStartDateChange = (event, value) => {
    // var state = { ...this.state, selected_age: value };
    // this.setState(state);
  };

  onEndDateChange = (event, value) => {
    // var state = { ...this.state, selected_age: value };
    // this.setState(state);
  };

  render() {
    if (!this.props.segments) {
      return null;
    }
    var gender = this.props.gender_value ? (
      <Chip onRequestDelete={this.onClearGender}>
        {this.props.gender_value >= 50 ? (
          <span> Mer än {this.props.gender_value}% kvinnor </span>
        ) : (
          <span> Mer än {100 - this.props.gender_value}% män </span>
        )}
      </Chip>
    ) : (
      ""
    );
    var age = this.props.age_value ? (
      <Chip onRequestDelete={this.onClearAge}>
        <span> Ålder {this.props.age_value} år </span>
      </Chip>
    ) : (
      ""
    );
    var reachvalue = Math.pow(10, this.props.reach_value);
    var reach = this.props.reach_value ? (
      <Chip onRequestDelete={this.onClearReach}>
        <span> Räckvidd på minst {os.formatNumber(reachvalue)} </span>
      </Chip>
    ) : (
      ""
    );
    var budgetvalue = Math.pow(10, this.props.budget_value);
    var budget = this.props.budget_value ? (
      <Chip onRequestDelete={this.onClearBudget}>
        <span> Budget på minst {os.formatNumber(budgetvalue)} </span>
      </Chip>
    ) : (
      ""
    );

    return (
      <aside
        id="filter"
        className={
          this.props.showFilter
            ? "right filter_open Page_Filter_Box Brand_Filter"
            : "right Page_Filter_Box Brand_Filter"
        }
      >
        <a className="close" onClick={this.props.actions.toggleRight}>
          ×
        </a>
        <div className="filter__sticky">
          <div className="filter__scroll">
            {/* <div className="Brand_Filter_Row">
              <h1>Mediabokaren</h1>
            </div> */}
            <div className="Brand_Filter_Row">
              <Label>Sök medier</Label>
              <TextField
                name="search"
                value={this.props.search_value}
                floatingLabelFixed={true}
                onChange={this.onSearchChange}
                style={{ width: "100%" }}
                floatingLabelText=""
              />
            </div>
            <div className="Brand_Filter_Row">
              <Label>Kanaler</Label>
              <ChipField
                name="selected_categories"
                floatingLabelFixed={true}
                onChange={this.onCategoriesChange}
                label=""
                options={this.props.categories}
              />
            </div>
            <div className="Brand_Filter_Row">
              <Label>Segment</Label>
              <ChipField
                name="selected_segments"
                floatingLabelFixed={true}
                onChange={this.onSegmentChange}
                label=""
                options={this.props.segments}
              />
            </div>
            <div className="Brand_Filter_Row">
              <Label>Period</Label>
              <div className="Brand_Filter_Period">
                <DateField
                  name="startdate"
                  id="startdate"
                  value={this.props.startdate_value}
                  onDateChange={this.onStartDateChange}
                  placeholder="Startdatum"
                />
                <span> » </span>
                <DateField
                  name="enddate"
                  id="enddate"
                  value={this.props.enddate_value}
                  onDateChange={this.onEndDateChange}
                  placeholder="Slutdatum"
                />
              </div>
              <div className="Brand_Filter_Range">
                <span>Startdatum</span>
                <span>Slutdatum</span>
              </div>
            </div>
            <div className="Brand_Filter_Row Brand_Filter_Slider">
              <span>{reach}</span>
              <Label>Räckvidd</Label>
              <Slider
                name="selected_reach"
                onChange={this.onReachChange}
                label="Räckvidd"
                min={0}
                max={7}
                step={1}
                value={this.props.reach_value}
              />
              <div className="Brand_Filter_Range">
                <span>10 st</span>
                <span>{os.formatNumber(Math.pow(10, 7))} st</span>
              </div>
            </div>
            <div className="Brand_Filter_Row Brand_Filter_Slider">
              <span>{gender}</span>
              <Label>Kön</Label>
              <Slider
                name="selected_gender"
                onChange={this.onGenderChange}
                disableFocusRipple={true}
                label="Räckvidd"
                min={0}
                max={100}
                step={1}
                value={this.props.gender_value}
              />
              <div className="Brand_Filter_Range">
                <span>100% män</span>
                <span>100% kvinnor</span>
              </div>
            </div>
            <div className="Brand_Filter_Row Brand_Filter_Slider">
              <span>{age}</span>
              <Label>Ålder</Label>
              <Slider
                name="selected_age"
                onChange={this.onAgeChange}
                disableFocusRipple={true}
                label="Ålder"
                min={16}
                max={80}
                step={1}
                value={this.props.age_value}
              />
              <div className="Brand_Filter_Range">
                <span>16 år</span>
                <span>80 år</span>
              </div>
            </div>
            <div className="Brand_Filter_Row Brand_Filter_Slider">
              <span>{budget}</span>
              <Label>Budget</Label>
              <Slider
                name="selected_budget"
                onChange={this.onBudgetChange}
                disableFocusRipple={true}
                label="Budget"
                min={0}
                max={7}
                step={1}
                value={this.props.budget_value}
              />
              <div className="Brand_Filter_Range">
                <span>10 kr</span>
                <span>{os.formatNumber(Math.pow(10, 7))} kr</span>
              </div>
            </div>
          </div>
        </div>
      </aside>
    );
  }
}

function mapStateToProps(state) {
  var segments = os.tree_to_array(state.segments.list.data);
  var categories = os.tree_to_array(state.categories.list.data);
  var mediagroupsfilter = os.tree_to_array(state.mediagroups.list.data);

  var props = {
    filters: state.filter,
    segments: segments,
    categories: categories,
    mediagroups: state.mediagroups.list.data,
    showFilter: state.menus && state.menus.open === TOGGLE_RIGHT
  };
  props.mediagroups_value =
    state.filters && state.filters[UPDATE_FILTER_MEDIAGROUPS]
      ? state.filters[UPDATE_FILTER_MEDIAGROUPS]
      : [];
  props.segments_value =
    state.filters && state.filters[UPDATE_FILTER_SEGMENTS]
      ? state.filters[UPDATE_FILTER_SEGMENTS]
      : [];
  props.categories_value =
    state.filters && state.filters[UPDATE_FILTER_CATEGORIES]
      ? state.filters[UPDATE_FILTER_CATEGORIES]
      : [];
  props.targets_value =
    state.filters && state.filters[UPDATE_FILTER_TARGETS]
      ? state.filters[UPDATE_FILTER_TARGETS]
      : [];
  props.search_value =
    state.filters && state.filters[UPDATE_FILTER_SEARCH]
      ? state.filters[UPDATE_FILTER_SEARCH]
      : "";
  props.age_value =
    state.filters && state.filters[UPDATE_FILTER_AGE]
      ? state.filters[UPDATE_FILTER_AGE]
      : undefined;
  props.gender_value =
    state.filters && state.filters[UPDATE_FILTER_GENDER]
      ? state.filters[UPDATE_FILTER_GENDER]
      : undefined;
  props.reach_value =
    state.filters && state.filters[UPDATE_FILTER_REACH]
      ? state.filters[UPDATE_FILTER_REACH]
      : undefined;
  props.budget_value =
    state.filters && state.filters[UPDATE_FILTER_BUDGET]
      ? state.filters[UPDATE_FILTER_BUDGET]
      : undefined;
  return props;
}

const mapDispatch = dispatch => {
  return {
    actions: bindActionCreators(
      { ...mediagroups, ...segments, ...categories, ...filters, ...menus },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatch)(BrandsFilter);



// WEBPACK FOOTER //
// ./src/pages/brands/BrandsFilter.jsx